module.exports = __webpack_public_path__ + "static/media/gif.88c467f6.gif";